import {
	Box,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";
import React, { useState } from "react";
import CommCard from "src/common/CommCard";
import { CommonPagination } from "src/common/CommonPagination";
import ModalsWrapper from "src/components/Modals/ModalsWrapper";
import { useGetQueryWithTotal } from "src/hooks/useGetQueryWithTotal";
import type { IRaffleParticipant } from "src/Types/module/raffleDraw/raffleDraw";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";
import ParticipantTableRow from "./ParticipantTableRow";
import CreateParticipantModal from "./CreateParticipantModal";

const ParticipantList: React.FC = () => {
	const [pagination, setPagination] = useState({ limit: 50, skip: 0 });
	const [search, setSearch] = useState("");
	const [openModal, setOpenModal] = useState(false);

	const { data, isLoading } = useGetQueryWithTotal<IRaffleParticipant[]>({
		endPoint: "/api/raffle-draw/admin/participant",
		queryKeys: ["raffle-participant", search, pagination.skip, pagination.limit],
		params: {
			...pagination,
			search: search || undefined,
		},
	});

	return (
		<>
			<CommCard
				showCardHeader
				headerTitle={`Participant List (${data?.total || 0})`}
				helmetTitle="BTTF - Raffle Draw Participant List"
				showButton
				btnText="Add Participant"
				handleBtnForModalFun={() => setOpenModal(true)}
				showSearch
				handleSearchFun={(val) => {
					setSearch(val);
					setPagination((prev) => ({ ...prev, skip: 0 }));
				}}
			>
				<TableContainer>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell>SL.</TableCell>
								<TableCell>Raffle No.</TableCell>
								<TableCell>User No.</TableCell>
								<TableCell>Participant</TableCell>
								<TableCell>Contact</TableCell>
								<TableCell>User Type</TableCell>
								<TableCell>Status</TableCell>
								<TableCell>Created At</TableCell>
								<TableCell>Actions</TableCell>
							</TableRow>
						</TableHead>

						{isLoading ? (
							<TableLoader />
						) : data?.data && data.data.length > 0 ? (
							<TableBody>
								{data.data.map((item, idx) => (
									<ParticipantTableRow
										key={item.id}
										item={item}
										serial={idx + 1 + pagination.skip}
									/>
								))}
							</TableBody>
						) : (
							<TableNotFound />
						)}
					</Table>
				</TableContainer>

				<Box p={2}>
					<CommonPagination
						total={data?.total}
						paginationCalFun={(limit: number, skip: number) => {
							setPagination({ limit, skip });
						}}
					/>
				</Box>
			</CommCard>

			<ModalsWrapper
				showModal={openModal}
				setShowModal={setOpenModal}
				modalData={{ title: "Add Raffle Participant" }}
				maxWidth="sm"
			>
				<CreateParticipantModal handleClose={() => setOpenModal(false)} />
			</ModalsWrapper>
		</>
	);
};

export default ParticipantList;
